import View from '@/components/atomic/atoms/layout/view/styled';
import styled from '@emotion/styled';

import { FrostedGlassBarProps } from './typings';

const FrostedGlassBar = styled(View)<FrostedGlassBarProps>(({ $height }) => ({
	width: '100%',
	display: 'block',
	background: 'rgba(255, 255, 255, 0.08)',
	boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.05)',
	backdropFilter: 'blur(58px)',
	height: `${$height}px`,
}));

export default FrostedGlassBar;
